const indicators = document.querySelector(".collection__subnav__indicators");
const scrollableArea = document.querySelector(".collection__subnav");

if (scrollableArea && indicators && !isOverflown(scrollableArea)) {
  indicators.classList.add("disabled");
}

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

function scrollSubnav(direction) {
  const margin = 20;
  const subnav = document.getElementById("collection__subnav");
  const leftIndicator = subnav.children[0].children[0];
  const rightIndicator = subnav.children[0].children[1];

  rightIndicator.classList.remove("scrolled-out");
  leftIndicator.classList.remove("scrolled-out");

  const screenWidth = window.innerWidth;
  const slidesPerScroll = Math.floor(screenWidth / 330);
  const scrollWidth = slidesPerScroll * 330;
  const newScroll =
    direction === "right"
      ? subnav.scrollLeft + scrollWidth
      : subnav.scrollLeft - scrollWidth;
  subnav.scrollLeft = newScroll;
  const maxScrollLeft = subnav.scrollWidth - subnav.clientWidth;

  if (newScroll + margin >= maxScrollLeft) {
    rightIndicator.classList.add("scrolled-out");
  }

  if (newScroll - margin <= 0) {
    leftIndicator.classList.add("scrolled-out");
  }
}

const toggles = document.querySelectorAll(".product-item__variants__toggle");
console.log("[variants] found toggles:", toggles.length);

toggles.forEach((toggle, i) => {
  if (toggle.getAttribute("toggle-listener") == "true") return;
  toggle.addEventListener("click", (e) => {
    console.log("[variants] toggle clicked:", i, toggle);
    toggle.classList.toggle("active");
  });
  toggle.addEventListener("touchstart", (e) => {
    console.log("[variants] touchstart on toggle:", i);
  });
  toggle.setAttribute("toggle-listener", "true");
});

const innerGrid = document.getElementById("main-collection-product-grid");
const grid = document.getElementById("CollectionProductGrid");

const facetForm = document.querySelector("facet-filters-form");
let isLoading = false;
let isPreloaded = false;
let isPreloading = false;
const scrollExtraMargin = 10;

const pageLoader = debounce(() => {
  const { currentPage, pageCount } = grid.dataset;

  if (currentPage === pageCount) return;

  const { shouldLoad } = getCurrentState();

  if (!isPreloaded && !isPreloading) {
    isPreloading = true;
    facetForm.preloadPage(+currentPage + 1, onPreload);
    return;
  }

  if (shouldLoad && !isLoading && !isPreloading) {
    startLoading();
    return;
  }
}, 200);

document.addEventListener("scroll", pageLoader);

function getCurrentState() {
  const { productsPerPage, currentPage, pageCount } = grid.dataset;

  if (currentPage === pageCount) {
    return { shouldPreload: false, shouldLoad: false };
  }

  // const { columns, rowGap } = deriveGridProperties();
  // const elementHeight = innerGrid.firstChild.getBoundingClientRect().height;
  // const productPageHeight =
  //   (productsPerPage / columns) * (elementHeight + rowGap) - rowGap;

  // const shouldPreload =
  //   innerGrid.getBoundingClientRect().bottom <
  //   productPageHeight / 2 + document.documentElement.clientHeight;

  const shouldLoad =
    grid.getBoundingClientRect().bottom <
    document.documentElement.clientHeight - scrollExtraMargin;

  return { shouldLoad };
}

function onPreload() {
  isPreloaded = true;
  isPreloading = false;

  const reachedBottom =
    grid.getBoundingClientRect().bottom <
    document.documentElement.clientHeight - scrollExtraMargin;
  if (reachedBottom) {
    startLoading();
  }
}

function startLoading() {
  const { currentPage } = grid.dataset;
  // const [svg] = document.getElementById("loader").children;
  // svg.innerHTML = `
  //   <path fill="#000" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
  //     <animateTransform
  //         attributeName="transform"
  //         attributeType="XML"
  //         type="rotate"
  //         dur="1s"
  //         from="0 50 50"
  //         to="360 50 50"
  //         repeatCount="indefinite" />
  //   </path>`;

  isLoading = true;
  facetForm.appendPage(+currentPage + 1, () => {
    isLoading = false;
    isPreloaded = false;
    isPreloading = false;
    document
      .getElementById("main-collection-product-grid")
      .classList.remove("loading");

    const toggles = document.querySelectorAll(
      ".product-item__variants__toggle",
    );

    const toggleClick = (toggle, e) => {
      toggle.classList.toggle("active");
    };

    toggles.forEach((toggle, key) => {
      if (toggle.getAttribute("toggle-listener") == "true") return;
      toggle.addEventListener("click", toggleClick.bind(null, toggle));
      toggle.setAttribute("toggle-listener", "true");
    });
  });
}

function deriveGridProperties() {
  if (document.documentElement.clientWidth <= 768) {
    return { columns: 2, rowGap: 24 };
  }

  if (
    document.documentElement.clientWidth > 768 &&
    document.documentElement.clientWidth < 1101
  ) {
    return { columns: 4, rowGap: 54 };
  }

  return { columns: 5, rowGap: 54 };
}
